/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_DevelopersInputs */



/**
* | output |
* | --- |
* | "Developers" |
*
* @param {Footer_DevelopersInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_developers = /** @type {((inputs?: Footer_DevelopersInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_DevelopersInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Entwickler")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Développeurs")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("开发者")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("開發者")
	if (locale === "ko") return /** @type {LocalizedString} */ ("개발자")
	return /** @type {LocalizedString} */ ("Developers")
});